export const HELP_PAGE_TITLE = 'Help';
export const MDAQRT_SPACE_KEY = '/rest/api/space/ACES';
export const PROJECTS = 'Projects';
export const TRAINING = 'Training';
export const CODE_DEVELOPMENT = 'Code Development';
export const REFERENCES = 'References';
